// extracted by mini-css-extract-plugin
module.exports = {"container":"Detail_container_26UkR","chevron":"Detail_chevron_2YoQG","usersTable":"Detail_usersTable_2kzrS"};